import * as WebBrowser from 'expo-web-browser';
import React, { useState } from 'react';
import { ImageBackground } from 'react-native';
import { Colors } from 'react-native-paper';
import { useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { ButtonWithIcon, Header, ModalAgreement } from '../../../components/common';
import { AppButton } from '../../../components/form';
import { Logout } from '../../../config/utils';
import styles from './styles';

const Profile = ({ navigation }) => {
  const { companyData } = useSelector((state) => state.company);
  const [modalAgreement, setModalAgreement] = useState(false);
  const handleButtonAgreement = async () => {
    if (companyData.contrato) {
      await WebBrowser.openBrowserAsync(companyData.contrato);
    } else {
      setModalAgreement(true);
    }
  };
  return (
    <>
      <ModalAgreement title="Atenção" agreement="Contrato Não Localizado." visible={modalAgreement} onDismiss={() => setModalAgreement(false)} />

      <Header
        canAlterPic="Company Alter Pic"
        navigation={navigation}
        profilePic={companyData.foto}
        userName={companyData.nome}
      />
      <ImageBackground source={leths_back} style={styles.viewBase}>
        <ButtonWithIcon icon="file-medical" title="Relatório PNFAM" onPress={() => navigation.navigate('Company Pnfam')} />
        <ButtonWithIcon icon="clipboard" title="Relatório Aulas" onPress={() => navigation.navigate('Company Report Classes')} />
        <ButtonWithIcon icon="handshake" title="Contrato Online" onPress={handleButtonAgreement} />
        <ButtonWithIcon icon="wallet" title="Financeiro" onPress={() => navigation.navigate('Company Finance')} />
        <AppButton
          size="bold"
          label="SAIR"
          rippleColor={Colors.white}
          style={styles.buttonBack}
          labelStyle={styles.textBack}
          onPress={() => Logout(navigation)}
        />
      </ImageBackground>
    </>
  );
};

export default Profile;
